publishingApp.factory("userService", function ($rootScope, $http, $injector) {
    return {
        //This service ensure the existence of the $rootScope.user before entering any view
        resolveUser: function () {
            if ($rootScope.user != null) {
                return $rootScope.user;
            } else {
                return $http.get($rootScope.apiUrl + 'login')
                    .success(function (res) {
                        //If the result is null then the user does not have publishing permissions
                        if (res.result == null) {
                            $injector.get('$state').go("no-permission");
                            return false;
                        } else {
                            $rootScope.user = res.result;

                            if(res.result.onboarding_completed === false){
                                var pubhubNewServer = document.getElementById("main-doc").dataset.pub_hub_url;
                                window.location.href = pubhubNewServer + '/onboarding';
                            }

                            return $rootScope.user;
                        }
                    })
                    .error(function () {
                        return false;
                    });
            }
        }
    };
});